function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 10.2L16.1621 11.0028C14.1785 12.1929 12.8946 14.2704 12.7172 16.5768C12.7073 16.7045 12.6043 16.8051 12.4764 16.8118L10.8107 16.8997C9.6581 16.9605 8.69343 16.0357 8.70549 14.8816L8.77806 7.93758C8.78977 6.81702 9.71976 5.92476 10.8398 5.95943L17.0523 6.15176C19.0165 6.21256 19.7244 8.77323 18.0703 9.83423L17.5 10.2Z",
  fill: "#FFAF00",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 3C9.89543 3 9 3.89543 9 5V16C9 17.1046 9.89543 18 11 18H20.5C20.7761 18 21 17.7761 21 17.5C21 17.2239 20.7761 17 20.5 17H11C10.4477 17 10 16.5523 10 16V5C10 4.44772 10.4477 4 11 4H20.5C20.7761 4 21 3.77614 21 3.5C21 3.22386 20.7761 3 20.5 3H11ZM8 9.5C8 9.22386 7.77614 9 7.5 9C7.22386 9 7 9.22386 7 9.5V11.5C7 11.7761 7.22386 12 7.5 12C7.77614 12 8 11.7761 8 11.5V9.5ZM12 5.5C12 5.22386 12.2239 5 12.5 5H19.5C19.7761 5 20 5.22386 20 5.5C20 5.77614 19.7761 6 19.5 6H12.5C12.2239 6 12 5.77614 12 5.5ZM12.5 11C12.2239 11 12 11.2239 12 11.5C12 11.7761 12.2239 12 12.5 12H19.5C19.7761 12 20 11.7761 20 11.5C20 11.2239 19.7761 11 19.5 11H12.5ZM11 19C11.2761 19 11.5 19.2239 11.5 19.5V19.9348C11.5 19.9708 11.5292 20 11.5652 20H12.9348C12.9708 20 13 19.9708 13 19.9348V19.5C13 19.2239 13.2239 19 13.5 19C13.7761 19 14 19.2239 14 19.5V19.9348C14 20.5231 13.5231 21 12.9348 21H11.5652C10.9769 21 10.5 20.5231 10.5 19.9348V19.5C10.5 19.2239 10.7239 19 11 19ZM19 19.5C19 19.2239 18.7761 19 18.5 19C18.2239 19 18 19.2239 18 19.5V19.9348C18 20.5231 18.4769 21 19.0652 21H20.5C20.7761 21 21 20.7761 21 20.5C21 20.2239 20.7761 20 20.5 20H19.0652C19.0292 20 19 19.9708 19 19.9348V19.5ZM12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14ZM11 14.5C11 13.6716 11.6716 13 12.5 13C13.3284 13 14 13.6716 14 14.5C14 15.3284 13.3284 16 12.5 16C11.6716 16 11 15.3284 11 14.5ZM19 14.5C19 14.2239 19.2239 14 19.5 14C19.7761 14 20 14.2239 20 14.5C20 14.7761 19.7761 15 19.5 15C19.2239 15 19 14.7761 19 14.5ZM19.5 13C18.6716 13 18 13.6716 18 14.5C18 15.3284 18.6716 16 19.5 16C20.3284 16 21 15.3284 21 14.5C21 13.6716 20.3284 13 19.5 13Z",
  fill: "#FFAF00"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 7.5L4.5 17.5L6 17.5L6.5 20.5L3 20.5L3 19",
  stroke: "#FFAF00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 8.5H7.5V12.5H5",
  stroke: "#FFAF00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 1.5,
  cy: 1.5,
  rx: 1.5,
  ry: 1.5,
  transform: "matrix(1 0 0 -1 3 7.5)",
  stroke: "#FFAF00",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgStation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/station.cff1a51f.svg";
export { ForwardRef as ReactComponent };